import { render } from "./Dashboard.vue?vue&type=template&id=27191e9f&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=27191e9f&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=27191e9f&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27191e9f"]])

export default __exports__